import { compose, path } from "ramda";
import { createSelector } from "reselect";
import * as model from "./model";

export const scopeSelector = state => state.modules.payment;

export const submitPaymentApi = compose(
  path(["api", "submitPayment"]),
  scopeSelector
);

export const checkoutApi = compose(path(["api", "checkout"]), scopeSelector);

export const getCardsApi = compose(path(["api", "getCards"]), scopeSelector);

export const getInvoiceApi = compose(
  path(["api", "getInvoice"]),
  scopeSelector
);

export const createInsiderPaymentInfoApi = compose(
  path(["api", "createInsiderPaymentInfo"]),
  scopeSelector
);

export const billingInfoApi = compose(
  path(["api", "billingInfo"]),
  scopeSelector
);

export const isPaying = createSelector(
  [submitPaymentApi, checkoutApi],
  (submit, checkout) => submit.isFetching || checkout.isFetching
);

export const getDefaultCardId = createSelector(
  [getCardsApi],
  api => api.data && model.getDefaultCardId(api.data)
);

export const isCreateFormVisible = compose(
  path(["ui", "isFormVisible"]),
  scopeSelector
);

export const getDeletingCardId = compose(
  path(["ui", "deletingCardId"]),
  scopeSelector
);

export const billingAccountBalanceApi = compose(
  path(["api", "billingAccountBalance"]),
  scopeSelector
);



// WEBPACK FOOTER //
// ./src/modules/payment/selectors.js